import React from "react";
import styled, { ThemeContext } from "styled-components";

import { S3Image } from "../S3";

interface LogoProps {
  className?: string;
  type: "light" | "dark";
  alt?: string;
  src?: string;
}

const Logo: React.ReactFCWithChildren<LogoProps> = ({
  className, type, alt = "Logo"
}) => {
  const theme = React.useContext(ThemeContext);
  const s3Key = type === "light" ? theme.customLightLogo : theme.customDarkLogo;
  const placeholder = type === "light" ? "/assets/mezze-small-white.svg" : "/assets/mezze.svg";

  return (
    <StyledS3Image
      className={[ className, type ].join(" ")}
      s3Key={s3Key}
      level="public"
      placeholder={placeholder}
      alt={alt}
    />
  );
};

const StyledS3Image = styled(S3Image)`
  max-width: initial;
  max-height: 100%;
  object-fit: contain;

  &.placeholder {
    position: static;
    transform: none;
    &.dark {
      width: 200px;
    }
    &.light {
      width: 50px;
    }
  }
`;

export default Logo;
